import React, { useEffect } from "react";
import { Stack, Box } from "@mui/material";
import dayjs from "dayjs";

import { HubButton, HubHookFormWrapper, HubToolbar } from "../../components";
import { useGetUserById, usePutUserData } from "../../hooks";

import { StyledDrawer } from "./styles";
import { EMPLOYEE_TYPES_DICT } from "../../constants/employees";
import CreateEmployeeHire from "../CreateEmployeeDialog/CreateEmployeeHire";
import CreateEmployeePersonal from "../CreateEmployeeDialog/CreateEmployeePersonal";
import CreateEmployeeAccount from "../CreateEmployeeDialog/CreateEmployeeAccount";

export const EditEmployeeDialog = ({ id, setOpen = () => {} }) => {
  const { data, isLoading } = useGetUserById({ id });
  const { mutate, isSuccess } = usePutUserData();

  const onClose = () => setOpen(null);

  useEffect(() => {
    isSuccess && onClose();
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      id,
      name: formData.name,
      email: formData.email,
      dob: dayjs(formData.dob).toISOString(),
      doh: dayjs(formData.doh).toISOString(),
      phone: formData.phone,
      type: Number(formData.type || EMPLOYEE_TYPES_DICT.FULLTIME),
      locationId: Number(formData.locationId),
      departmentIds: formData.departmentIds?.map((d) => Number(d.id)),
      roleId: Number(formData.roleId),
      invite: false,
    };
    mutate(payload);
  };

  const defaultValues = {
    name: data?.name,
    email: data?.email,
    dob: data?.dob,
    doh: data?.doh,
    phone: data?.phone,
    type: data?.isFulltime
      ? EMPLOYEE_TYPES_DICT.FULLTIME
      : EMPLOYEE_TYPES_DICT.PARTTIME,
    locationId: Number(data?.locationId),
    departmentIds: data?.departments,
    roleId: Number(data?.roleId),
  };

  return (
    <StyledDrawer anchor="right" open={!!id} onClose={onClose}>
      <Stack overflow="hidden">
        <HubToolbar
          label="Edit User Details"
          subtitle="Update User Profile"
          onClose={onClose}
        />
        <Box
          sx={{
            height: "100%",
            overflowY: "auto",
            padding: "0 0 25px 0",
            "&::-webkit-scrollbar": { display: "none !important" },
          }}
        >
          <HubHookFormWrapper defaultValues={defaultValues} onSubmit={onSubmit}>
            <Stack padding="25px" gap="25px">
              <CreateEmployeeHire />
              <CreateEmployeePersonal />
              <CreateEmployeeAccount isUpdate />
              <HubButton
                variant="contained"
                size="xsmall"
                type="submit"
                label="Update User"
                disabled={isLoading}
              />
            </Stack>
          </HubHookFormWrapper>
        </Box>
      </Stack>
    </StyledDrawer>
  );
};

export default EditEmployeeDialog;
